import curry from "lodash.curry";

export function deleteObjectProperty(obj, propToDelete) {
  const { [propToDelete]: deleted, ...objWithoutProp } = obj; //eslint-disable-line no-unused-vars
  return objWithoutProp;
}

export function addObjectProperty(obj, propToAdd) {
  return { ...obj, [propToAdd]: null };
}

export const deleteObjectProperties = curry(function deleteObjectProperties(propsToDelete, obj) {
  return propsToDelete.reduce(deleteObjectProperty, obj);
});

export const addObjectProperties = curry(function addObjectProperties(propsToAdd, obj) {
  return propsToAdd.reduce(addObjectProperty, obj);
});
